import React from "react";

const PostPreviewTags = props => {
  const { tags } = props;
  return tags ? (
    <React.Fragment>
      <div className="events-page-post-tags">
        {tags?.map((tag, index) => (
          <div key={index} className="events-page-post-tags-item">
            {tag}
          </div>
        ))}
      </div>
    </React.Fragment>
  ) : null;
};

export default PostPreviewTags;
